import { useTheme } from '@mui/material/styles';

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    body3: true;
    body4: true;
  }
}

export const useActiveTheme = () => {
  const theme = useTheme();
  return theme.palette.mode;
};

